import { type ShiftType, type ShopperWithShifts } from 'domains/shifts/components/types'

export function countScheduledDevicesForDay(
  shoppers: ShopperWithShifts[],
  shiftType: ShiftType,
  mem = {}
) {
  if (!shoppers) {
    return 0
  }

  return shoppers.reduce((count, shopper) => {
    if (mem[shopper.id]) {
      return count
    }

    if (shopper.shifts.filter(shift => shift.shift_type === shiftType).length < 1) {
      return count
    }

    mem[shopper.id] = true

    return count + 1
  }, 0)
}

export function countScheduledDevicesForWeek(
  shoppers: ShopperWithShifts[][],
  shiftType: ShiftType
) {
  if (!shoppers) {
    return 0
  }

  const mem = {}

  return shoppers.reduce(
    (count, shoppersForDay) => count + countScheduledDevicesForDay(shoppersForDay, shiftType, mem),
    0
  )
}
